import { render, staticRenderFns } from "./DependencyTreeItem.vue?vue&type=template&id=23de2a70&scoped=true&"
import script from "./DependencyTreeItem.vue?vue&type=script&lang=ts&"
export * from "./DependencyTreeItem.vue?vue&type=script&lang=ts&"
import style0 from "./DependencyTreeItem.vue?vue&type=style&index=0&id=23de2a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de2a70",
  null
  
)

export default component.exports